import { IUserGroup } from '@boldpenguin/sdk';

export interface IEditDialogData {
  existingUser: ITerminalUser | null;
  preventAccountTypeChange: boolean;
}

export enum UserInvitationStatus {
  Accepted = 'Accepted',
  Active = 'Active',
  Deactivated = 'Deactivated',
  Expired = 'Expired',
  NotCreated = 'Not created',
  Pending = 'Pending',
  Queued = 'Queued to send',
  Sent = 'Sent',
}

export interface IUserGroupMembership {
  id: string;
  is_primary: boolean;
  name: string;
  user_group_id: string;
}

export interface IUserGroupMembershipParams {
  id?: string;
  user_group_id?: string;
  _destroy?: boolean;
}

export interface ITerminalUser {
  id: string;
  first_name: string;
  last_name: string;
  name: string;
  email: string;
  phone: string | null;
  invitation_status_string: UserInvitationStatus;
  is_approved: boolean;
  primary_user_group: IUserGroup;
  user_group_memberships: IUserGroupMembership[];
  npn: string | null;
}

export interface ITerminalUserParams {
  first_name?: string;
  last_name?: string;
  email?: string;
  username?: string; // This shouldn't be set, it will automatically be the email
  phone?: string;
  npn?: string;
  user_group_memberships_attributes?: IUserGroupMembershipParams[];
  invite_after_onboarding?: boolean;
}
